<template>
    <Link :href="'/song/' + song.id" class="block">
        <div class="w-full p-4 rounded-lg bg-nomad-800 hover:bg-nomad-700 hover:shadow-lg transition-all duration-300"
            :class="{ 'bg-nomad-accent/20 border-l-4 border-nomad-accent': jumbo }">
            <div class="flex items-center gap-4">
                <!-- Song Image -->
                <img :src="song.cover" :alt="song.name" class="rounded-lg object-cover flex-shrink-0"
                    :class="{ 'h-32 w-32': jumbo, 'h-16 w-16': !jumbo }" />

                <!-- Song Info -->
                <div class="flex-1 min-w-0">
                    <h3 class="font-semibold text-white truncate" :class="{ 'text-xl': jumbo, 'text-lg': !jumbo }">
                        {{ song.name }}
                    </h3>
                    <h4 class="text-nomad-50 text-md font-light truncate">
                        {{ song.artist.name }}
                    </h4>
                    <Featuring :artists="song.featuring" />
                </div>

                <!-- Action Buttons -->
                <div class="flex gap-2 flex-shrink-0">
                    <button @click.prevent="addToFavorites(song.id)"
                        class="p-2 rounded-lg text-xl transition-all hover:scale-110 hover:shadow-md"
                        :class="song.is_liked ? 'text-nomad-accent icon-heart' : 'text-nomad-300 hover:text-nomad-accent icon-heart'"
                        aria-label="add to favorites"></button>
                    <button @click.prevent="prepareCurrent({ id: song.id, type: 'SONG' })"
                        class="p-2 rounded-lg text-nomad-300 hover:text-nomad-accent text-xl transition-all hover:scale-110 hover:shadow-md icon-play"
                        aria-label="play song"></button>
                </div>
            </div>
        </div>
    </Link>
</template>
<script setup>
defineProps({ song: Object, jumbo: Boolean });
</script>
<script>
import { mapState, mapActions } from "vuex";
import { Link } from "@inertiajs/vue3";
import Featuring from "@/components/Featuring.vue";
export default {
    components: {
        Link,
        Featuring,
    },
    methods: {
        ...mapActions("favorites", ["addToFavorites"]),
        ...mapActions("current", ["prepareCurrent"]),
    },
};
</script>
